var _g, _g2, _line, _g3, _rect, _rect2, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpNewCeilingToFloor3ArcFa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "547.7px",
    height: "650px",
    viewBox: "0 0 547.7 650",
    enableBackground: "new 0 0 547.7 650",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M483.5,640c-0.8,0-1.5-0.2-2.1-0.5c0,0.4,0,0.9,0,1.3c0,0.5-0.1,0.9-0.3,1.4c-0.2,0.5-0.4,1-0.7,1.5 c-0.3,0.4-0.7,0.8-1.2,1.1c-0.5,0.4-1.1,0.6-1.8,0.8c-0.7,0.2-1.4,0.3-2.3,0.4h-0.4c-0.8,0-1.5-0.1-2.1-0.3 c-0.6-0.2-1.2-0.5-1.7-1c-0.4-0.4-0.8-0.9-1.1-1.4c-0.3-0.5-0.5-1.1-0.6-1.8c0-0.4-0.1-0.7-0.1-1.1s0-0.7,0.1-1 c0-0.3,0.1-0.6,0.2-0.9c0.1-0.3,0.1-0.6,0.2-0.8c0.2-0.6,0.4-1.1,0.6-1.5c0.2-0.4,0.4-0.7,0.5-0.9l1.4,1c-0.1,0.1-0.2,0.2-0.3,0.4 s-0.2,0.4-0.3,0.7s-0.2,0.5-0.3,0.9c-0.1,0.3-0.2,0.6-0.2,1c-0.1,0.3-0.1,0.7-0.1,1s0,0.7,0.1,1c0,0.2,0.1,0.3,0.1,0.5 c0.1,0.2,0.1,0.4,0.3,0.6c0.1,0.2,0.3,0.4,0.4,0.7s0.4,0.4,0.7,0.6s0.6,0.3,1,0.4c0.4,0.1,0.8,0.2,1.3,0.2h0.1c0,0,0.1,0,0.1,0 c0,0,0.1,0,0.1,0c1.2-0.1,2.2-0.3,3-0.7c0.8-0.4,1.3-1,1.5-1.8c0.2-0.5,0.2-1,0.2-1.5c0-0.5,0-1-0.1-1.4s-0.2-0.9-0.3-1.3 c-0.1-0.4-0.3-0.7-0.4-1.1c-0.1-0.1-0.1-0.2-0.2-0.4c-0.1-0.1-0.1-0.2-0.2-0.4c0-0.1-0.1-0.2-0.1-0.2c0,0-0.1-0.1-0.1-0.1l1.5-0.9 c0,0,0.1,0.1,0.2,0.3c0.1,0.2,0.3,0.5,0.4,0.8c0.3,0.6,0.6,1.1,0.9,1.4c0.3,0.4,0.5,0.6,0.8,0.8c0.3,0.2,0.5,0.3,0.7,0.3 c0.2,0,0.4,0.1,0.6,0.1c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.2,0.6C483.9,639.9,483.7,640,483.5,640z  M476.7,635l-1.4,1.4l-1.4-1.4l1.4-1.4L476.7,635z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M482.6,639.1c0-0.2,0.1-0.4,0.2-0.6s0.4-0.2,0.6-0.2h0.7c0.5,0,1,0,1.4-0.1s0.8-0.2,1.2-0.3 c0.3-0.2,0.6-0.4,0.8-0.6s0.3-0.6,0.3-1c0-0.3,0-0.7-0.1-1c0-0.3-0.1-0.7-0.3-1.2l1.6-0.5c0.1,0.2,0.1,0.4,0.1,0.6 c0,0.2,0.1,0.5,0.1,0.7c0,0.2,0.1,0.5,0.1,0.7c0,0.2,0,0.5,0.1,0.7c0,0.2,0,0.4,0.1,0.7c0,0.2,0.1,0.5,0.2,0.7s0.2,0.4,0.4,0.5 c0.2,0.1,0.4,0.2,0.7,0.2c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.3,0.4,0.3,0.6c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.6,0-1.1-0.1-1.5-0.3c-0.4-0.2-0.7-0.5-0.9-0.8c-0.2,0.2-0.5,0.4-0.8,0.5 c-0.3,0.1-0.7,0.3-1.1,0.3c-0.4,0.1-0.8,0.2-1.2,0.2s-0.9,0.1-1.3,0.1h-0.7c-0.2,0-0.4-0.1-0.6-0.2S482.6,639.4,482.6,639.1z  M486.2,643.3l-1.4,1.4l-1.4-1.4l1.4-1.4L486.2,643.3z M489.7,643.3l-1.4,1.4l-1.4-1.4l1.4-1.4L489.7,643.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M490.1,639.1c0-0.2,0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.3h0c0.5,0,0.9-0.1,1.2-0.2 c0.3-0.2,0.6-0.4,0.9-0.6s0.5-0.6,0.7-0.9s0.4-0.7,0.5-1c0.2-0.3,0.3-0.6,0.5-0.9c0.2-0.3,0.3-0.5,0.5-0.8c0.5-0.6,1.2-1,1.9-1 c0.9,0,1.6,0.4,2.2,1.1c0.5,0.6,0.7,1.3,0.8,2.1c0.1,0.4,0.1,0.8,0,1.2c0,0.4-0.1,0.7-0.3,1.1c-0.2,0.4-0.4,0.8-0.7,1 s-0.6,0.5-1,0.6c-0.6,0.2-1.4,0.1-2.2-0.2c-0.6-0.2-1.2-0.6-1.8-1c0,0-0.1,0.1-0.1,0.1c-0.9,0.9-2,1.3-3.3,1.3h0 c-0.2,0-0.4-0.1-0.6-0.2C490.2,639.6,490.1,639.3,490.1,639.1z M495.3,637.1c0.5,0.4,1,0.7,1.4,0.8s0.8,0.2,1.1,0.1 c0.1,0,0.2-0.1,0.3-0.2s0.2-0.3,0.2-0.4c0.1-0.2,0.1-0.4,0.1-0.6c0-0.2,0-0.5,0-0.7c0,0,0-0.1,0-0.2c0-0.1-0.1-0.2-0.1-0.3 c0-0.1-0.1-0.2-0.2-0.4c-0.1-0.1-0.2-0.2-0.3-0.4c-0.1-0.1-0.2-0.2-0.3-0.3s-0.3-0.1-0.5-0.1c-0.1,0-0.2,0-0.3,0.1 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.3-0.3,0.5s-0.2,0.5-0.4,0.7L495.3,637.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M505.4,634.3c0.2,0.5,0.3,1.1,0.5,1.6c0.1,0.2,0.1,0.5,0.2,0.7c0.1,0.2,0.1,0.5,0.2,0.7 c0.1,0.2,0.1,0.5,0.1,0.7c0,0.2,0.1,0.4,0.1,0.6c0,0.1,0,0.1,0,0.2c0,0.1,0,0.2,0,0.3c0,0.5-0.1,1-0.2,1.5 c-0.1,0.5-0.4,0.9-0.6,1.4s-0.6,0.9-0.9,1.3c-0.4,0.4-0.8,0.8-1.2,1.1c-0.4,0.4-0.9,0.7-1.3,1c-0.5,0.3-1,0.6-1.4,0.8l-0.8-1.5 c0.6-0.3,1.2-0.7,1.8-1c0.6-0.4,1.1-0.8,1.5-1.3c0.4-0.5,0.8-1,1.1-1.5s0.4-1.1,0.4-1.6c0,0,0-0.1,0-0.1s0-0.1,0-0.2v0 c0-0.2,0-0.4-0.1-0.6c0-0.2-0.1-0.4-0.1-0.7c-0.1-0.2-0.1-0.4-0.2-0.7c-0.1-0.2-0.1-0.4-0.2-0.6c-0.1-0.5-0.3-1-0.4-1.5 L505.4,634.3z M505.8,630.8l-1.4,1.4l-1.4-1.4l1.4-1.4L505.8,630.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M530,637.9C530,637.9,530,637.9,530,637.9c-0.1,0.1-0.1,0.2-0.2,0.2c0.4,0.1,0.7,0.1,1.1,0.2 c0.4,0,0.7,0.1,1.1,0.1c0.2,0,0.4,0.1,0.6,0.2c0.2,0.2,0.3,0.4,0.3,0.6c0,0.1,0,0.2-0.1,0.3c0,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.2,0.1-0.3,0.2c-0.1,0-0.2,0.1-0.3,0.1c-0.7,0-1.5-0.1-2.2-0.2c-0.7-0.1-1.3-0.3-1.9-0.5c-0.1,0-0.2,0.1-0.3,0.1 c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0.1-0.6,0.2-1,0.3c-0.4,0.1-0.8,0.1-1.3,0.2c-0.5,0.1-1,0.1-1.5,0.1c-0.5,0-1,0-1.6,0 c-1.8,0-3.2-0.2-4.4-0.7c-1.2-0.4-2-1.1-2.5-2c-0.2-0.4-0.4-0.8-0.5-1.2s-0.1-0.8-0.1-1.2s0.1-0.7,0.1-1.1 c0.1-0.3,0.2-0.6,0.3-0.9s0.2-0.5,0.3-0.6c0.1-0.2,0.1-0.2,0.1-0.3l1.5,0.8c0,0,0,0.1-0.1,0.2c-0.1,0.1-0.1,0.3-0.2,0.4 c-0.1,0.2-0.1,0.4-0.2,0.6c-0.1,0.2-0.1,0.5-0.1,0.7s0,0.5,0,0.8c0,0.3,0.1,0.5,0.3,0.8c0.2,0.3,0.4,0.5,0.7,0.8 c0.3,0.2,0.6,0.4,1,0.6c0.4,0.1,0.9,0.3,1.4,0.3c0.5,0.1,1.2,0.1,1.9,0.1c0.5,0,1,0,1.4,0c0.4,0,0.8,0,1.1-0.1 c0.3,0,0.6-0.1,0.9-0.1c0.3,0,0.5-0.1,0.7-0.1c-0.8-0.7-1.2-1.4-1.2-2.3c0-0.5,0.1-1.1,0.2-1.5c0.2-0.5,0.4-0.9,0.7-1.3 c0.3-0.4,0.7-0.7,1.1-0.9c0.4-0.2,0.8-0.3,1.3-0.3c0.4,0,0.8,0.1,1.1,0.2c0.3,0.1,0.7,0.4,0.9,0.6c0.1,0.1,0.2,0.2,0.3,0.4 c0.1,0.2,0.2,0.3,0.3,0.6c0.1,0.2,0.2,0.5,0.2,0.7c0.1,0.3,0.1,0.6,0.1,0.9C530.8,636.3,530.5,637.2,530,637.9z M527.9,637.5 c0.2-0.1,0.5-0.3,0.6-0.5c0.2-0.2,0.3-0.3,0.4-0.5c0.1-0.2,0.1-0.4,0.2-0.6c0-0.2,0-0.4,0-0.6c0-0.4-0.1-0.7-0.2-1 c-0.1-0.2-0.2-0.4-0.4-0.5c-0.1-0.1-0.3-0.2-0.4-0.2c-0.1,0-0.2,0-0.3,0c-0.2,0-0.3,0.1-0.5,0.2s-0.4,0.3-0.5,0.5 s-0.3,0.4-0.4,0.7s-0.2,0.6-0.2,1c0,0.3,0.1,0.5,0.4,0.8c0.3,0.3,0.6,0.5,1.1,0.7L527.9,637.5z M529.2,628.4l-1.4,1.4l-1.4-1.4 l1.4-1.4L529.2,628.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M531.1,639.1c0-0.2,0.1-0.4,0.3-0.6s0.4-0.2,0.7-0.2h0.9c0.3,0,0.7,0,1.1,0s0.7,0,1.1-0.1 c0.3-0.1,0.7-0.2,0.9-0.3s0.5-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9s0-0.7-0.1-1.1c-0.1-0.2-0.2-0.5-0.5-0.9 c-0.3-0.4-0.6-0.8-0.9-1.2c-0.4-0.4-0.8-0.9-1.2-1.3c-0.5-0.4-0.9-0.9-1.4-1.2l0.2-1.8l7.1-3.1l0.7,1.6l-6.2,2.6 c0.3,0.2,0.6,0.5,0.9,0.8c0.3,0.3,0.7,0.6,1,1c0.4,0.5,0.8,1,1.1,1.4s0.5,0.9,0.7,1.3c0.2,0.4,0.3,0.8,0.3,1.1 c0.1,0.4,0.1,0.7,0,1c0,0.3-0.1,0.6-0.2,0.9s-0.2,0.5-0.3,0.7c-0.5,0.9-1.4,1.5-2.6,1.7c-0.2,0-0.5,0.1-0.8,0.1h-2.8 c-0.3,0-0.5-0.1-0.7-0.2S531.1,639.4,531.1,639.1z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 54.3,
    y: 80.1,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.0951,
    width: 362,
    height: 6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 405.3,
    y: 77.1,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.6,
    y: 77.1,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 1.2603,
    width: 24,
    height: 12
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9679,
    x1: 0,
    y1: 638.8,
    x2: 460,
    y2: 638.8
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 173.7,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 196.7,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 380.8,
    y: 66.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.9625,
    width: 7,
    height: 24
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72.2,
    y: 66.7,
    fill: "#FFFFFF",
    stroke: "#464545",
    strokeWidth: 0.9625,
    width: 7,
    height: 24
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9515,
    x1: 320.7,
    y1: 91.4,
    x2: 320.7,
    y2: 623
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "311.9,94 320.7,78.7 329.5,94  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "311.9,620.4 320.7,635.7 329.5,620.4  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9515,
    x1: 229.5,
    y1: 91.4,
    x2: 229.5,
    y2: 623
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "220.6,94 229.5,78.7 238.3,94  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "220.6,620.4 229.5,635.7 238.3,620.4  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9515,
    x1: 139.3,
    y1: 91.4,
    x2: 139.3,
    y2: 623
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "130.5,94 139.3,78.7 148.1,94  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "130.5,620.4 139.3,635.7 148.1,620.4  "
  })))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.75,
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6174,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 452.5,107.7 462,98.2 2.3,98.2 11.2,107.7 451.2,107.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 66,
    opacity: 0.7,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.5848,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 460,
    height: 32.1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M327.6,4.7c0.1,0.7,0.2,1.3,0.3,1.9c0.1,0.6,0.1,1.1,0.1,1.6c0,1.6-0.3,2.7-1,3.5 c-0.3,0.4-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.4,0.3c-0.2,0-0.4,0-0.6-0.1c-0.2,0-0.5-0.1-0.7-0.2c-0.2-0.1-0.5-0.3-0.7-0.5 c-0.2-0.2-0.4-0.4-0.6-0.7l-0.2,0.4c-0.4,0.4-0.8,0.8-1.3,1c-0.5,0.2-1,0.3-1.6,0.3c-0.3,0-0.6,0-0.8-0.1s-0.5-0.1-0.7-0.2 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0.1,0.8,0.2,1.6,0.2,2.4c0.1,0.8,0.1,1.6,0.1,2.4c0,0.8,0.1,1.6,0.1,2.4c0,0.8,0,1.5,0,2.3 h-2.4c0-0.3,0-0.7,0-1c0-0.4,0-0.7,0-1c0-1.2,0-2.3-0.1-3.4s-0.2-2.2-0.4-3.3s-0.4-2-0.6-3c-0.2-1-0.5-1.9-0.9-2.7 c0,0,0-0.1-0.1-0.2c0,0,0-0.1,0-0.1c-0.1-0.3-0.3-0.6-0.4-0.9c-0.1-0.3-0.3-0.6-0.5-0.9l2.2-1.3c0.1,0.1,0.1,0.2,0.2,0.4 s0.2,0.3,0.2,0.5s0.2,0.3,0.2,0.5c0.1,0.2,0.2,0.3,0.2,0.5c0.2,0.4,0.4,0.8,0.6,1.2c0.2,0.5,0.4,0.9,0.6,1.3 c0.2,0.3,0.3,0.6,0.5,0.8c0.2,0.2,0.4,0.4,0.6,0.5c0.2,0.1,0.5,0.1,0.9,0.1c0.3,0,0.5,0,0.6-0.1c0.1-0.1,0.3-0.2,0.4-0.4 c0.2-0.3,0.4-0.6,0.5-1.1s0.2-1.1,0.2-1.7c0-0.1,0-0.2,0-0.5c0-0.2,0-0.5,0-0.7c0-0.2,0-0.5,0-0.7c0-0.2,0-0.3,0-0.4l2.4-0.3 c0,0,0,0.1,0,0.1s0,0.1,0,0.1c0,0.1,0,0.2,0.1,0.4c0,0.2,0,0.4,0.1,0.7c0,0.5,0.1,1,0.2,1.6s0.2,1,0.3,1.5 c0.1,0.3,0.2,0.5,0.3,0.7s0.2,0.3,0.3,0.4s0.2,0.1,0.3,0.2s0.1,0,0.2,0c0.2,0,0.4,0,0.5-0.1c0.1-0.1,0.2-0.1,0.2-0.2 c0,0,0.1-0.1,0.1-0.2c0.1-0.1,0.1-0.2,0.1-0.4c0-0.2,0.1-0.4,0.1-0.6s0-0.5,0-0.8c0-0.4,0-0.8-0.1-1.3c-0.1-0.5-0.1-1.1-0.3-1.8 L327.6,4.7z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M234.5,4.8c0,0,0,0.1,0,0.2c0,0.1,0,0.3,0.1,0.6c0,0.2,0,0.5,0.1,0.8c0,0.3,0,0.6,0,0.9 c0,1.9-0.5,3.3-1.3,4.3v0c-0.4,0.5-0.9,0.9-1.5,1.1c-0.6,0.3-1.2,0.4-1.9,0.4c-0.4,0-0.7,0-1-0.1c-0.3-0.1-0.6-0.1-0.9-0.3 c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.3c0.1,0.8,0.2,1.5,0.2,2.4c0.1,0.8,0.1,1.6,0.1,2.4s0.1,1.6,0.1,2.4c0,0.8,0,1.5,0,2.2h-2.4 c0-1.3,0-2.6,0-3.9c0-1.3-0.1-2.5-0.2-3.7s-0.3-2.4-0.5-3.5s-0.5-2.1-0.9-3c-0.2-0.4-0.4-0.8-0.5-1.2c-0.2-0.4-0.4-0.8-0.7-1.2 l2-1.3c0.1,0.2,0.3,0.4,0.4,0.6c0.1,0.2,0.2,0.4,0.3,0.7s0.2,0.5,0.3,0.7c0.1,0.3,0.2,0.5,0.4,0.8c0.2,0.4,0.4,0.8,0.6,1.2 s0.4,0.6,0.6,0.9c0.2,0.3,0.5,0.4,0.8,0.6c0.3,0.1,0.7,0.2,1.2,0.2c0.3,0,0.6-0.1,0.9-0.2c0.2-0.1,0.5-0.3,0.6-0.5 c0.2-0.2,0.3-0.4,0.4-0.6c0.1-0.2,0.2-0.5,0.2-0.8c0.1-0.3,0.1-0.5,0.1-0.8s0-0.6,0-0.8c0-0.3,0-0.7-0.1-1c0-0.3-0.1-0.6-0.1-0.8 L234.5,4.8z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M139,23c0-1.6,0-3.2-0.1-4.7c-0.1-1.6-0.2-3.1-0.4-4.5c-0.2-1.4-0.5-2.8-0.8-4s-0.8-2.4-1.5-3.3l2-1.3 c0.7,1.1,1.2,2.3,1.7,3.7s0.8,3,1,4.8c0.1,0.8,0.2,1.6,0.2,2.4c0.1,0.8,0.1,1.6,0.1,2.4c0,0.8,0.1,1.6,0.1,2.4c0,0.8,0,1.5,0,2.2 H139z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpNewCeilingToFloor3ArcFa);
export default __webpack_public_path__ + "static/media/help_new_ceiling_to_floor_3_arc_fa.9b4239a7c7c8d51dad948543b24668ba.svg";
export { ForwardRef as ReactComponent };